module.exports = __webpack_public_path__ + "static/media/030.35755a3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/030.jpg
// module id = 377
// module chunks = 0